module.exports = __webpack_public_path__ + "static/media/areaMeasure.b9eb20d1.svg";